import { useMutation } from '@tanstack/react-query'
import { apiClient } from '@/api/client'
import { endpoints } from '@/api/endpoints'

interface IpRequestResponse {
  submitted: boolean
}

export function useRequestIP(): ReturnType<typeof useMutation<IpRequestResponse, unknown, string>> {
  return useMutation({
    mutationFn: (message: string) =>
      apiClient.post<IpRequestResponse>(endpoints.ips.request, { message }),
  })
}
